const initialCharitiesState = {
    charities: [],
    charitiesLoaded: false
}

const charityReducer = (state = initialCharitiesState, action) => {
    switch (action.type) {
        case 'LOAD_CHARITIES':
            return Object.assign({}, state, {
                charities: action.charities,
                charitiesLoaded: true
            })
        default:
            return state
    }
}

export default charityReducer;